import Error from '../../../model/Error.js';
import TableColumn from '../../../dto/offering/TableColumn.js';
import axios from 'axios';

export default class TableColumnRepository {
    static findByClub(clubId, offeringId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/offerings/${offeringId}/table-columns`)
                .then((response) => resolve(response.data.data.map((data) => TableColumn.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
